import { SVGAttributes } from 'react';

const Local = (props: SVGAttributes<SVGElement>) => (
    <svg width={40} height={40} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" {...props}>
        <path
            d="M10.5 18v10c0 1.534 1.34 2.778 3 2.778h14c1.66 0 3-1.244 3-2.778V18M35.5 15.5 20.5 3l-15 12.5M38 39.25c-5.49-3.563-10.27-5.028-17.5-5-7.23.029-12.01 1.437-17.5 5"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            clipRule="evenodd"
            d="m20.5 23-4.26-4.233c-.77-.731-.96-1.847-.47-2.772.36-.69 1.05-1.172 1.85-1.296.8-.124 1.61.126 2.18.672l.7.662.7-.663a2.585 2.585 0 0 1 2.18-.672c.8.123 1.49.606 1.85 1.296.49.924.3 2.04-.47 2.772L20.5 23Z"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M25.5 3h5v5" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default Local;
